var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"search-input"},[_c('el-autocomplete',{staticClass:"w-full",attrs:{"value":_vm.value,"fetch-suggestions":_vm.querySearch,"size":"small","popper-class":"search-input-popper","clearable":_vm.clearable},on:{"input":_vm.onInput,"select":_vm.onSelect,"change":_vm.onInput}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }